import script from "./SetgamesScoreboard.vue?vue&type=script&setup=true&lang=js"
export * from "./SetgamesScoreboard.vue?vue&type=script&setup=true&lang=js"

import "./SetgamesScoreboard.vue?vue&type=style&index=0&id=0dbbe583&lang=css"

const __exports__ = script;

export default __exports__